import { http } from './request';
import type {
  TenantListItem,
  TenantDetail,
  HealthScore,
  DashboardMetrics,
  SubscriptionDistribution,
  ConversionStage,
  ChurnRiskTenant,
  MonthlyRevenue,
  MonthlyGrowth,
  Announcement,
  CreateAnnouncementRequest,
  UpdateAnnouncementRequest,
  FreezeTenantRequest,
  PaginatedResponse,
  TenantListParams,
  AnnouncementListParams,
} from '../types/admin';

// 租户管理
export const adminApi = {
  // 获取租户列表
  getAdminTenants: (params: TenantListParams) =>
    http.get<PaginatedResponse<TenantListItem>>('/api/v1/admin/tenants', params),

  // 获取租户详情
  getAdminTenantDetail: (id: number) =>
    http.get<TenantDetail>(`/api/v1/admin/tenants/${id}`),

  // 获取租户健康度评分
  getAdminTenantHealth: (id: number) =>
    http.get<HealthScore>(`/api/v1/admin/tenants/${id}/health`),

  // 冻结租户
  freezeTenant: (id: number, data: FreezeTenantRequest) =>
    http.post<void>(`/api/v1/admin/tenants/${id}/freeze`, data),

  // 解冻租户
  unfreezeTenant: (id: number) =>
    http.post<void>(`/api/v1/admin/tenants/${id}/unfreeze`, {}),

  // 注销租户
  deleteTenant: (id: number) =>
    http.delete<void>(`/api/v1/admin/tenants/${id}`),
};

// 运营仪表盘
export const dashboardApi = {
  // 获取仪表盘数据
  getDashboardMetrics: () =>
    http.get<DashboardMetrics>('/api/v1/admin/dashboard'),

  // 获取订阅版本分布
  getSubscriptionDistribution: () =>
    http.get<{ distributions: SubscriptionDistribution[] }>('/api/v1/admin/analytics/subscription'),

  // 获取试用转化漏斗
  getTrialConversionFunnel: () =>
    http.get<{ stages: ConversionStage[] }>('/api/v1/admin/analytics/trial-conversion'),

  // 获取流失风险租户
  getChurnRiskTenants: (limit?: number) =>
    http.get<ChurnRiskTenant[]>('/api/v1/admin/dashboard/churn-risk', { limit }),

  // 获取收入趋势
  getRevenueTrend: (months?: number) =>
    http.get<MonthlyRevenue[]>('/api/v1/admin/dashboard/revenue-trend', { months }),

  // 获取租户增长趋势
  getGrowthTrend: (months?: number) =>
    http.get<MonthlyGrowth[]>('/api/v1/admin/dashboard/growth-trend', { months }),
};

// 公告管理
export const announcementApi = {
  // 获取公告列表
  getAdminAnnouncements: (params: AnnouncementListParams) =>
    http.get<PaginatedResponse<Announcement>>('/api/v1/admin/announcements', params),

  // 创建公告
  createAnnouncement: (data: CreateAnnouncementRequest) =>
    http.post<Announcement>('/api/v1/admin/announcements', data),

  // 更新公告
  updateAnnouncement: (id: number, data: UpdateAnnouncementRequest) =>
    http.put<Announcement>(`/api/v1/admin/announcements/${id}`, data),

  // 删除公告
  deleteAnnouncement: (id: number) =>
    http.delete<void>(`/api/v1/admin/announcements/${id}`),

  // 发布公告
  publishAnnouncement: (id: number) =>
    http.post<void>(`/api/v1/admin/announcements/${id}/publish`, {}),

  // 撤回公告
  withdrawAnnouncement: (id: number) =>
    http.post<void>(`/api/v1/admin/announcements/${id}/withdraw`, {}),
};
